import React, { useState, useRef, useEffect } from 'react';
import BlogCard from './BlogCard';
import { BiNews } from "react-icons/bi";
import { motion } from "framer-motion";
import { ClipLoader } from "react-spinners";
import { css } from "@emotion/react";
import { images } from "./Images";
const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

const blogSources = [

    {
        id: "01",
        source: "Forbes Media",
        title: "International Business News",
        link: "https://forbes.com/",
        catch: `Hover on this card to get the latest international news from top sources like Forbes media.`,
        tags: ["News", "International", "Business"],
        url: "https://api.newscatcherapi.com/v2/latest_headlines?topic=business&lang=en"
    },
    {
        id: "02",
        source: "TechCabal",
        title: "Nigerian Tech News",
        link: "https://techcabal.com",
        catch: `Hover on this card to get the latest Nigerian tech news directly from sources like Techcabal.com. 
        TechCabal is a future-focused publication that speaks to African innovation and technology in depth.`,
        tags: ["Article", "Nigerian", "Technology", "News"],
        url: "https://api.newscatcherapi.com/v2/latest_headlines?countries=NG&topic=tech&lang=en"
    },
    {
        id: "03",
        source: "LegitNG",
        title: "Nigerian Business News",
        link: "https://www.legit.ng/",
        catch: `Hover on this card to get the latest Nigerian business news directly from sources like legit.ng, blueprint.ng, businessday.ng and so on.`,
        tags: ["News", "Business", "Nigeiran"],
        url: "https://api.newscatcherapi.com/v2/latest_headlines?countries=NG&topic=business&lang=en"
    },
];

const getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

const Blog = () => {
    const [isVisible, setIsVisible] = useState(false);
    const readRef = useRef();
    const [ source, setSource ] = useState("");
    const [ displayText, setDisplayText ] = useState("");
    const [ title, setTitle ] = useState("");
    const [ image, setImage ] = useState("");
    const [ content, setContent ] = useState("");
    // const [ techcrunch, setTechcrunch ] = useState({});
    // const [ gadget, setGadget ] = useState({});
    // const [ wallstreet, setWallstreet ] = useState({});
    const [ apiUrl, setApiUrl ] = useState("");
    const [ readMoreUrl, setReadMoreUrl ] = useState("");
    const [ loading, setLoading ] = useState(false);
    const scrollRef = useRef(null);
    //source, title and content

    useEffect(()=>{
        const makeCall = async () => {
            await apiCall();
        }
        makeCall();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isVisible, content]);

    const apiCall = async () => {
        setLoading(true);
        if(apiUrl){
            try {
                const makeCall = await fetch(apiUrl, {
                    method: "GET",
                    headers: {
                        "x-api-key": "D7SVzu9xvv6gjhvGzRYl9FcgrJgV0J43HSLloy7CljY"
                    }
                });
                const result = await makeCall.json();
                if(result.status === "ok"){
                    let content = result.articles[0].summary;
                    let neededContent = content.split(/\s+/);
                    neededContent = neededContent.slice(0, 50);
                    neededContent = neededContent.join(" ");
                    neededContent += "...";
                    setSource(result.articles[0].rights);
                    setTitle(result.articles[0].title);
                    setImage(result.articles[0].media);
                    setContent(neededContent);
                    setReadMoreUrl(result.articles[0].link);
                }else{
                    const blankContent = "Oops! We've reached our API calls limit, and we are afraid we won't be able to serve you with any more news until our request to extend the free trial is approved. Thanks for your understanding.";
                    setSource("bunmioladipupo.vercel.app");
                    setTitle("We've run out of free news API calls.");
                    setImage(images[getRandomInt(0,images.length)]);
                    setContent(blankContent);
                    setReadMoreUrl("https://bunmioladipupo.vercel.app/");
                }
                setLoading(false);
                
            } catch (error) {
                return;
            }
        }
        setLoading(false);
        typingEffect(content);
        return;
    }

  const toggleONVisibility = async (url) => {
    setIsVisible(true);
    if(url) {
        setApiUrl(url);
    }
  };

  const toggleOFFVisibility = () => {
    setIsVisible(false);
    setDisplayText("");
    setContent("");
  }

  const typingEffect = (text) => {
    let newText = "";
    let currentIndex = 0;
    if (text) {
        if(currentIndex < text.length) {
            setInterval(()=>{
                if(currentIndex === text.length) {
                    return;
                }
                newText += text[currentIndex];
                currentIndex++;
                setDisplayText(newText);
            }, 30);
            
        }
    }
    return;
  }
  return (
    <>
    <div className='max-w-contentContainer mx-auto px-4 py-24'>
        <div className='w-full flex flex-col items-center'>
            <h2 className='inline-block text-3xl font-titleFont font-semibold'>
                <BiNews className='inline-block text-textGreen'/>&nbsp;News Blog
            </h2>
            <p className='text-sm text-textGreen'>
                stay informed while browsing my portfolio
            </p>
        </div>
        <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 mt-10 lgl:px-10'>
            {
                blogSources.map(blog=> {
                    return  <BlogCard 
                    title={blog.title}
                    description={blog.catch}
                    link={blog.link}
                    listItem={blog.tags}
                    toggleONVisibility={()=>toggleONVisibility(blog.url)} 
                    toggleOFFVisibility={toggleOFFVisibility}
                    />
                   
                })
            }
            
        </div>
        <div className='mt-12 flex items-center justify-center'>
            <a href="https://medium.com/" target="_blank" rel='noreferrer'>
                <button className='w-36 h-12 rounded-md text-textGreen text-[13px] border border-textGreen hover:bg-hoverColor duration-300'>
                    Read from Medium
                </button>
            </a>
        </div>
    </div>

<div>
<div className={`slide-in-div ${isVisible ? 'visible' : 'hide'} pb-10 scrollbar-none`} ref={scrollRef} onMouseEnter={()=>toggleONVisibility(apiUrl)} onMouseLeave={toggleOFFVisibility}>
    {
        !loading ?
            <div className='py-6 px-4' >
                <span className='block text-center text-lg text-teal-950 font-bold'>Article</span>
                <span className='text-teal-950 font-bold'>Source: {source} </span>
                <h3 className='text-teal-950 font-bold'>Title: {title} </h3>
                <img src={image} alt="blog" className='w-[300px] h-[150px] m-5'/>
                <p className='overflow-y-scroll pb-10'> {displayText} </p>
                <div className='p-2 m-1' ref={readRef}>
                    <a href={readMoreUrl} target="_blank" rel='noreferrer'>
                        <button className='w-36 h-12 rounded-md text-textDark text-[13px] border border-textDark hover:bg-hoverColor duration-300'>
                            Read from website
                        </button>
                    </a>
                </div>
                {/* displayText */}
            </div>
            :
            <div className='flex align-middle justify-center py-6 px-4 mt-16'>
                <ClipLoader
                color="#000"
                loading={true}
                css={override}
                size={50}
                /> 
            </div>
    }
</div>
</div>
</>
            
  )
}

export default Blog